import React, { FC } from 'react';

import styled from 'styled-components';
import Navbar from '../../components/Navbar';
import Footer from '../../components/Footer';

import Hero from './Hero';
import About from './About';
import Unique from './Unique';
import Products from './Products';
import Charts from './Charts';
import Burns from './Burns';
import Comparison from './Comparison';
// import Media from './Media';
import Partners from './Partners';
import { media } from '../../components/Layout/breakpoints';
// import Team from './Team';

interface Props {
  data: Queries.HomePageQuery;
}

const PageWrapper = styled.div`
  padding-top: 120px;
  ${media.md`
    padding-top: 80px;

  `}
`;

const View: FC<Props> = ({ data }) => {
  const { childJson } = data.page || {};

  return (
    <>
      <Navbar />
      <PageWrapper>
        <Hero hero={childJson?.hero || null} />
        <About about={childJson?.about || null} />
        <Unique unique={childJson?.unique || null} />
        <Products products={childJson?.products || null} />
        <Charts charts={childJson?.charts || null} />
        <Comparison comparison={childJson?.comparison || null} />
        <Burns burns={childJson?.burns || null} />
        {/* <Media media={childJson?.media || null} /> */}
        <Partners partners={childJson?.partners || null} />
        {/* <Team team={childJson?.team || null} /> */}

        <Footer />
      </PageWrapper>
    </>
  );
};

export default View;
